import { runFingerprintProFlow } from "@/utils/fingerprintPro"

export const useFetchFingerprintPro = () => {
  const fetchFingerprintPro = () => runFingerprintProFlow()

  return {
    fetchFingerprintPro
  }
}

export default useFetchFingerprintPro
